<template>
  <v-form ref="form" id="form" v-model="valid">
    <v-text-field
      :mask="mask.cnpj"
      v-model="empresa.cnpj"
      :rules="empresa.cnpj && empresa.cnpj.length > 11 ? cnpjRules : cpfRules"
      label="CNPJ/CPF da empresa:"
      color="primary"
      type="text"
      class="input-required"
      id="empresa-cnpj"
      ref="cnpj"
      clearable
      @keydown.delete="mask ? mask.cnpj = '' : ''"
      @keyup="trocaCampoCpfCnpj($event, empresa.cnpj)"
      @blur="verificaCNPJ($event)"
      required
      validate-on-blur
    ></v-text-field>

    <v-text-field
      v-model="empresa.razao"
      :rules="razaoRules"
      label="Razão Social:"
      type="text"
      class="input-required"
      id="empresa-razao"
      clearable
      validate-on-blur
      browser-autocomplete="background-color: red;"
      @blur="returnEmpresa($event)"
      required
    ></v-text-field>

    <v-autocomplete
      v-model="auxEstado"
      validate-on-blur
      item-text="nome"
      class="input-required"
      :items="arrayEstados"
      label="UF:"
      id="empresa-uf"
      persistent-hint
      color="teal"
      no-data-text="Consulta de Estado indisponível"
      return-object
      @change="setUfEmpresa(), returnEmpresa($event)"
      :rules="razaoRules"
    ></v-autocomplete>
  </v-form>
</template>
<script>
import Empresa from "@/domain/conta/empresa/Empresa.js";
import Certificado from "@/domain/conta/empresa/certificado/Certificado.js";
import EmpresasService from "@/domain/conta/empresa/EmpresaService.js";
import {estados} from "@/domain/ibge/estados.js"
import Vue from "vue";

export default {
  components: {},
  data: () => ({
    empresa: new Empresa(),
    cert: new Certificado(),
    valid: false,
    arrayEstados: [],
    resource: "",
    auxEstado: "",
    showPassword: false,
    trocaCPFCNPJ: false,
    mask: { cnpj: "" },
    cpfRules: [
      v => !!v || "Campo obrigatório",
      cpf => {
        let sum, rest;
        if (
          cpf === undefined ||
          cpf === null ||
          cpf.trim().length === 0 ||
          cpf === "00000000000" ||
          cpf === "11111111111" ||
          cpf === "22222222222" ||
          cpf === "33333333333" ||
          cpf === "44444444444" ||
          cpf === "55555555555" ||
          cpf === "66666666666" ||
          cpf === "77777777777" ||
          cpf === "88888888888" ||
          cpf === "99999999999"
        ) {
          return "CPF inválido";
        }
        cpf = cpf
          .replace(".", "")
          .replace(".", "")
          .replace("-", "");

        sum = 0;
        for (let i = 1; i <= 9; i++) {
          sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }
        rest = (sum * 10) % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(9, 10))) {
          return "CPF inválido";
        }

        sum = 0;
        for (let i = 1; i <= 10; i++) {
          sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
        }
        rest = (sum * 10) % 11;

        if (rest === 10 || rest === 11) {
          rest = 0;
        }
        if (rest !== parseInt(cpf.substring(10, 11))) {
          return "CPF inválido";
        }
        return true;
      }
    ],

    cnpjRules: [
      v => !!v || "Campo obrigatório",
      v => {
        if (v == null) {
          return false;
        }
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        if ((v = v.replace(/[^\d]/g, "")).length != 14) return "CNPJ inválido";

        if (/0{14}/.test(v)) return "CNPJ inválido";

        for (var i = 0, n = 0; i < 12; n += v[i] * b[++i]);
        if (v[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        for (var i = 0, n = 0; i <= 12; n += v[i] * b[i++]);
        if (v[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        return true;
      }
    ],
    razaoRules: [v => !!v || "Campo obrigatório"],
    passRules: []
  }),
  computed: {
    emailErrors: function() {},
    getEstados: async function() {
      this.arrayCidades = [];
      delete Vue.http.headers.common["Authorization"];
      this.resource = this.$resource(
        "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
      );
      this.resource.query().then(
        success => {
          this.arrayEstados = success.body;

          return success.body;
        },
        failed => {
          this.arrayEstados = estados;
          return estados;
        }
      );
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getEstados;
      this.service = new EmpresasService(this.$http);
    });
  },
  methods: {
    setUfEmpresa: function() {
      if (
        this.auxEstado.hasOwnProperty("id") &&
        this.auxEstado.id != undefined
      ) {
        this.empresa["uf"] = this.auxEstado.id;
      }
    },
    trocaCampoCpfCnpj: function(e, v) {
      if (!v || (v && v.length == 0)) {
        this.mask.cnpj = "";
      } else {
        if (this.trocaCPFCNPJ && v && v.length >= 12) {
          this.mask.cnpj = "##.###.###/####-##";
        } else if (v && v.length >= 11) {
          this.trocaCPFCNPJ = true;
          this.mask.cnpj = "###.###.###-###";
        } else {
          this.trocaCPFCNPJ = false;
          this.mask.cnpj = "###.###.###-##";
        }
      }
    },
    verificaCNPJ($event) {
      this.setRazao();
      this.consultaCNPJbd();
      this.returnEmpresa($event);
    },
    setRazao() {
      this.service.getAPIReceita(this.empresa.cnpj).then(success => {
        if (success && success.body) {
          if (success.body.hasOwnProperty("nome")) {
            this.empresa.razao = success.body.nome;
          }
          if (success.body.hasOwnProperty("uf") && success.body.uf.length > 0) {
            this.arrayEstados.forEach(estado => {
              if (
                success.body.uf.toLocaleLowerCase() ==
                estado.sigla.toLocaleLowerCase()
              ) {
                this.auxEstado = estado;
                this.empresa["uf"] = estado.id;
              }
            });
          }
          this.$refs.cnpj.validate();
        }
      });
    },
    consultaCNPJbd() {
      this.service.getEmpresasCnpj(this.empresa.cnpj).then(
        success => {
          // trocar para algo melhor
          if (this.cnpjRules[this.cnpjRules.length - 1].name.length != 0) {
            this.cnpjRules.pop();
          }
          if (this.cpfRules[this.cpfRules.length - 1].name.length != 0) {
            this.cpfRules.pop();
          }
          if (success && success.status != 404) {
            this.cnpjRules.push(function indisponivel(value) {
              if (
                success.body.items.length > 0 &&
                value == success.body.items[0].cnpj
              ) {
                return "CNPJ já utilizado no sistema";
              }
              return true;
            });
            this.cpfRules.push(function indisponivel(value) {
              if (
                success.body.items.length > 0 &&
                value == success.body.items[0].cnpj
              ) {
                return "CPF já utilizado no sistema";
              }
              return true;
            });
          }
          this.$refs.cnpj.validate();
          return this.$refs.cnpj.valid;
        },
        failed => {
          return failed;
        }
      );
    },
    getFile(file) {
      this.cert.file = file;
      this.setRequiredPass();
    },
    setRequiredPass: function() {
      if (
        this.passRules.length > 0 &&
        this.passRules[this.passRules.length - 1].name.length != 0
      ) {
        this.passRules.pop();
      }

      if (this.cert.file != undefined) {
        this.passRules.push(function obrigatorio(value) {
          if (!value || value.length == 0) {
            return "Campo obrigatório";
          }
          return true;
        });
      }
      this.$refs.passCert.validate();
      this.returnEmpresa();
    },
    returnEmpresa: function(e) {
      // this.setFile(e);
      //Seta o arquivo do input file e torna a senha obrigatória

      //se Tudo estiver de acordo Envia
      if (this.verificaCampos()) {
        this.empresa["cnpj"] = this.empresa["cnpj"].replace(/[^\d]+/g, "");
        return this.$emit("getEmpresa", [this.empresa, this.cert]);
      } else {
        return this.$emit("getEmpresa", false);
      }
    },
    verificaCampos: function() {
      var cont = 0;

      var fields = [
        document.querySelector("#empresa-cnpj"),
        document.querySelector("#empresa-razao"),
        document.querySelector("#empresa-uf")
      ];
      fields.forEach(item => {
        if (item.value != null && item.value != "") {
          cont++;
        }
      });
      if (cont >= fields.length - 2) {
        if (this.$refs.form.validate()) {
          return true;
        }
      }
      return false;
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/conta/precadastro/Empresa.vue